import { useSchoolYear } from "@/contexts/SchoolYearContext";

/** Sélecteur de l'année consultée (en-tête) : l'année active est signalée, les autres sont en consultation. */
export default function SchoolYearSelect() {
  const { years, consulted, active, consult } = useSchoolYear();
  const otherYear = consulted !== active;

  return (
    <label
      className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${
        otherYear ? "border-accent-300 bg-accent-50 text-accent-800" : "border-primary-200 bg-primary-100 text-primary-800"
      }`}
      title={otherYear ? `Vous consultez ${consulted} ; l'année active de l'école est ${active}` : "Année active de l'école"}
    >
      <i className={otherYear ? "ri-history-line" : "ri-calendar-check-line"}></i>
      <span className="hidden sm:inline">Année</span>
      <select
        value={consulted}
        onChange={(e) => consult(e.target.value === active ? null : e.target.value)}
        className="cursor-pointer bg-transparent font-semibold focus:outline-none"
        aria-label="Année scolaire consultée"
      >
        {years.length === 0 && <option value={consulted}>{consulted || "—"}</option>}
        {years.map((y) => (
          <option key={y.id} value={y.label}>
            {y.label}
            {y.active ? " (active)" : ""}
          </option>
        ))}
      </select>
    </label>
  );
}
